export default __webpack_public_path__ + "c26a300665d1a5443639f98c09bef929.png";